import Modal from "../../common/Modal";
import { ChangeEvent, FormEvent, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Group, Passenger } from "../../../types/common.types";
import GeneralInput from "../../common/GeneralInput";
import { TCountryCode } from "countries-list";
import CountryInput from "../../common/CountryInput";
import validate from "../../../utils/validateForm";
import { submitGroup } from "../../../schema/group";
import { useGlobal } from "../../../context/global";
import AllyService from "../../../services/ally.service";
import { useAlly } from "../../../context/ally";

export default function CreateGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { setNewGroup, setNewGroupReservationData, setIsCreateGroupModalOpen } = useAlly()

    const initialPassenger = {
        name: '',
        nationality: 'CL' as TCountryCode,
        email: '',
        phone: '',
        rut_passport: '',
        hotel: '',
        remark: ''
    } as Passenger
    const [ groupMembers, setGroupMembers ] = useState<Partial<Passenger>[]>([initialPassenger])

    function onChangeNumberPassengers(e: ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        if (value === '') {
            setGroupMembers([])
            return
        }
        const number = parseInt(value)
        if (number > groupMembers.length) {
            setGroupMembers((prevData) => {
                const newMembers = Array.from({length: number - prevData.length}, () => ({
                    ...initialPassenger,
                }))
            return prevData.concat(newMembers)
            })
        } else {
            setGroupMembers((prevData) => prevData.slice(0, number))
        }
    }

    function onChangeGroupMember(e: ChangeEvent<HTMLInputElement>, index: number) {
        const name = e.target.name
        let value: string | number = e.target.value
        if (e.target.type === 'number') value = Number(value)
            setGroupMembers((prevData) => {
                const newMembers = [...prevData]
                const oldMember = newMembers[index]
                newMembers[index] = {
                    ...oldMember,
                    [name]: value
                }
                return newMembers
            })
    }

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setIsLoading(true)
        try {
            validate(submitGroup, groupMembers, true)
            let newGroupCorrectID: Partial<Passenger>[] = []
            for (let i = 0; i < groupMembers.length; i++) {
                const passsenger = groupMembers[i];
                const new_passenger_id = (await AllyService.createPassenger(passsenger)).data
                const new_passenger = {
                    ...passsenger,
                    ...new_passenger_id
                }
                newGroupCorrectID.push(new_passenger)
            }
            setNewGroup(newGroupCorrectID)
            const newGroup: Group = await (await AllyService.createGroup()).data
            setNewGroupReservationData(prevData => ({
                ...prevData,
                group_id: newGroup.id,
            }))
            setMessage({
                type: 'success',
                content: 'Passengers and group successfully created'
            })
        } catch (error) {
            console.log(error);
            
            setMessage({
                type: 'error',
                content: 'Error in data entered, make sure to fill all required fields'
            })
        } finally {
            setTimeout(() => {
                setMessage(undefined)
            }, 2500)
            setIsLoading(false)
        }
    }

    return (
        <Modal
        onSubmit={onSubmit}
        >
            <h1>Create new group</h1>
            <GeneralInput
            type="number"
            min={0}
            max={10}
            defaultValue={1}
            label="Number of passengers"
            onChange={onChangeNumberPassengers}
            />
            {
                groupMembers.map((member, index) => {
                    return (
                        <div style={{ margin: '10px 0'}} key={index} className="group-member">
                            <h2>Passenger {index + 1}</h2>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Name"
                                value={member.name || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="Carlos Perez"
                                name="name"
                                style={{marginBottom: '20px'}}
                                required
                                />
                                <GeneralInput
                                label="Email*"
                                value={member.email || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="example@example.com"
                                name="email"
                                type="email"
                                style={{marginBottom: '20px'}}
                                required
                                />
                            </div>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Phone"
                                value={member.phone || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="+58 412-0713771"
                                name="phone"
                                style={{marginBottom: '20px'}}
                                required
                                />
                                <GeneralInput
                                label="Rut / Passport"
                                value={member.rut_passport || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="XXXXXXXX-Z"
                                name="rut_passport"
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Hotel"
                                value={member.hotel || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="APANATOR"
                                name="hotel"
                                style={{marginBottom: '20px'}}
                                />
                                <GeneralInput
                                label="Age"
                                value={member.age || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="18"
                                name="age"
                                type="number"
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                            <div style={{display: 'flex',  gap: '10px', flexWrap: 'wrap'}}>
                                <GeneralInput
                                label="Remark"
                                value={member.remark || ''}
                                onChange={e => onChangeGroupMember(e, index)}
                                placeholder="Vegetarian"
                                name="remark"
                                style={{marginBottom: '20px'}}
                                />
                                <CountryInput
                                label="Nationality"
                                name="nationality"
                                value={member.nationality}
                                onChange={(e) => onChangeGroupMember(e, index)}
                                style={{marginBottom: '20px'}}
                                />
                            </div>
                        </div>
                    )
                })
            }
            <div className="actions">
                <button type="submit">Continue</button>
            </div>
            <div className="close" title="close"
            onClick={() => setIsCreateGroupModalOpen(false)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}